import React from 'react';

import { Group, useMantineTheme } from '@mantine/core';
import { IconCopy, IconEdit, IconEye, IconTrashX } from '@tabler/icons-react';
import Menu from 'components/Menu';
import { WorkoutTemplateList } from 'types';

interface ActionsCellProps {
  template: WorkoutTemplateList;
  permission: boolean;
  onPreview: (template: WorkoutTemplateList) => void;
  onEdit: (template: WorkoutTemplateList) => void;
  onDuplicate: (template: WorkoutTemplateList) => void;
  onDelete: (template: WorkoutTemplateList) => void;
}

const ActionsCell = ({
  template,
  permission,
  onPreview,
  onEdit,
  onDuplicate,
  onDelete,
}: ActionsCellProps): JSX.Element => {
  const theme = useMantineTheme();
  const iconSize = theme.fontSizes.sm;

  return (
    <Group position='right' px='xs'>
      <Menu
        position='bottom-end'
        disabled={!permission}
        items={[
          { title: 'Preview', onClick: () => onPreview(template), icon: <IconEye size={iconSize} /> },
          { title: 'Edit', onClick: () => onEdit(template), icon: <IconEdit size={iconSize} /> },
          { title: 'Duplicate', onClick: () => onDuplicate(template), icon: <IconCopy size={iconSize} /> },
          {
            title: 'Delete',
            onClick: () => onDelete(template),
            icon: <IconTrashX size={iconSize} />,
            color: 'red',
          },
        ]}
      />
    </Group>
  );
};

export default ActionsCell;
